import React, { createContext, useContext, useState, useCallback } from 'react';

const TapInEventContext = createContext({
  showTapIn: () => {},
  closeTapIn: () => {},
  tapInEventId: null,
  tapInEvent: null,
});

export const TapInEventProvider = ({ children }) => {
  const [tapInEventId, setTapInEventId] = useState(null);
  const [tapInEvent, setTapInEvent] = useState(null);

  const showTapIn = useCallback((eventId, eventData) => {
    setTapInEventId(eventId);
    setTapInEvent(eventData);
  }, []);

  const closeTapIn = useCallback(() => {
    setTapInEventId(null);
    setTapInEvent(null);
  }, []);

  return (
    <TapInEventContext.Provider value={{ showTapIn, closeTapIn, tapInEventId, tapInEvent }}>
      {children}
    </TapInEventContext.Provider>
  );
};

export const useTapInEvent = () => useContext(TapInEventContext);
